import React, { useState, useMemo } from "react";
import { useAgentsLocal } from "./useAgentsLocal";
import LexacquireTopnav from "./lexacquiretopnav";
import "./Newest.css";

export default function Newest() {
  const { agents: rawAgents, loading } = useAgentsLocal();

  // Normalize shape (mirrors Acquire)
  const normalise = (raw) => {
    if (raw.name) return raw;
    return {
      id: raw.slug || raw.agent_name,
      name: raw.agent_name || "",
      description: raw.tagline || "",
      industry: raw.industry || "",
      category: raw.category || "",
      logo: raw.logo_url || "",
      url: raw.url || "",
      website_url: raw.website_url || "",
      buzz: raw.buzz || "",
      overview: raw.overview || "",
      key_features: raw.key_features || [],
      use_cases: raw.use_cases || [],
      viewCount: raw.viewCount || 0,
      voteCount: raw.voteCount || 0,
      reviewCount: raw.reviewCount || 0,
      ratingAvg: raw.ratingAvg || null,
      trendingScore: raw.trendingScore || null,
      featured: raw.featured || false,
      featuredOrder: raw.featuredOrder || 0,
      createdAt: raw.createdAt || null,
    };
  };

  // Build normalized array
  const agents = useMemo(() => rawAgents.map(normalise), [rawAgents]);

  // Sort by createdAt descending, take top 10
  const newestAgents = useMemo(() => {
    return [...agents]
      .sort((a, b) => {
        const da = a.createdAt ? new Date(a.createdAt) : new Date(0);
        const db = b.createdAt ? new Date(b.createdAt) : new Date(0);
        return db.getTime() - da.getTime();
      })
      .slice(0, 10);
  }, [agents]);

  // Local state for modal
  const [selected, setSelected] = useState(null);

  return (
    <div className="newest-page">
      {/* ─── TOP NAV ─── */}
      <LexacquireTopnav />

      {loading ? (
        <p className="newest-loading">Loading…</p>
      ) : (
        <>
          <h2>Newest AI Agents</h2>
          <p className="newest-subtitle">
            Check out the latest AI agents added to our marketplace.
          </p>

          {newestAgents.length === 0 ? (
            <p className="newest-note">No agents have been added yet.</p>
          ) : (
            <div className="newest-grid">
              {newestAgents.map((agent) => (
                <div key={agent.id} className="newest-card">
                  {agent.logo ? (
                    <img
                      src={agent.logo}
                      alt={agent.name}
                      className="newest-logo"
                    />
                  ) : (
                    <div className="newest-logo-placeholder" />
                  )}
                  <div className="newest-info">
                    <h3 className="newest-name">{agent.name}</h3>
                    <p className="newest-desc">{agent.description}</p>
                  </div>
                  <button
                    className="newest-learnmore"
                    onClick={() => setSelected(agent)}
                  >
                    Learn More →
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* ─── DETAILS MODAL ─── */}
      {selected && (
        <div className="agent-modal" onClick={() => setSelected(null)}>
          <div
            className="agent-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="agent-modal-close"
              onClick={() => setSelected(null)}
            >
              ×
            </button>

            {selected.logo && (
              <img
                src={selected.logo}
                alt={selected.name}
                className="agent-modal-logo"
              />
            )}

            <h2>{selected.name}</h2>
            <p>{selected.description}</p>

            <p>
              <strong>Industry:</strong> {selected.industry || "—"}
            </p>
            <p>
              <strong>Category:</strong> {selected.category || "—"}
            </p>
            {selected.buzz && (
              <p>
                <strong>Buzz:</strong> {selected.buzz}
              </p>
            )}

            {selected.overview && (
              <>
                <h3>Overview</h3>
                <p>{selected.overview}</p>
              </>
            )}

            {selected.key_features.length > 0 && (
              <>
                <h3>Key Features</h3>
                <ul>
                  {selected.key_features.map((f) => (
                    <li key={f}>{f}</li>
                  ))}
                </ul>
              </>
            )}

            {selected.use_cases.length > 0 && (
              <>
                <h3>Use Cases</h3>
                <ul>
                  {selected.use_cases.map((u) => (
                    <li key={u}>{u}</li>
                  ))}
                </ul>
              </>
            )}

            <div className="agent-modal-links">
         
              {selected.website_url && (
                <>
                  {" • "}
                  <a
                    href={selected.website_url}
                    target="_blank"
                    rel="noreferrer"
                    className="modal-link"
                  >
                    Official Website ↗
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
